import useFacebookPermissionStep from './useFacebookPermissionStep';

export default useFacebookPermissionStep;
